import { register } from "@shopify/theme-sections";
import { waitForElm } from "../helpers/util";

const initFeed = () => {
  HTMLElement.prototype.wrap = function (elms) {
    if (!elms.length) elms = [elms];
    for (let i = elms.length - 1; i >= 0; i--) {
      let child = i > 0 ? this.cloneNode(true) : this;
      const el = elms[i];
      const parent = el.parentNode;
      const sibling = el.nextSibling;
      child.classList.add("insta-feed-item", "insta-feed-item-" + i);
      child.appendChild(el);
      if (sibling) {
        parent.insertBefore(child, sibling);
      } else {
        parent.appendChild(child);
      }
    }
  };

  const instaFeed = document.getElementById("insta-feed");
  const children = instaFeed.children;
  const div = document.createElement("div");
  let wrapper = null;

  div.wrap(children);

  [...document.querySelectorAll(".insta-feed-item")].forEach((el, i) => {
    if (i % 10 === 0) {
      wrapper = document.createElement("div");
      wrapper.classList.add("col-feed-item");
      instaFeed.appendChild(wrapper);
    }
    wrapper.appendChild(el);
  });
};

register("social-callout", {
  onLoad: function (e) {
    if (
      this.container
        .querySelector("#insta-feed")
        .classList.contains("custom-grid")
    )
      waitForElm(".instafeed-lightbox").then(() => {
        initFeed();
      });
  },
});
